import { router } from '../../utils';
import { createEvent } from './createEvent';
import { isBot } from './isBot';
import { verifyHumanity } from './verifyHumanity';
export const antibotContract = router({
    isBot,
    createEvent,
    verifyHumanity,
}, {
    pathPrefix: '/antibot',
});
